export default __webpack_public_path__ + "static/media/img-0291-zambia-full-face.160a71a1.png";